/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomRadioGroup from '../../shared/CustomRadioGroup';
import { assignOption } from '../constants';
import { Rule } from './Rule';
import Department from './Department';

const RoleMapping = ({
  setData,
  departmentData,
  data,
  rules,
  selectedRule,
  assignType,
  setAssignType,
  mandatoryRuleCoditions,
  setMandatoryRuleCoditions,
}) => {
  const [department, setDepartment] = useState([]);
  const [conditions, setConditions] = useState([]);

  useEffect(() => {
    selectedRule ? setAssignType('rule') : setAssignType('department');
    if (selectedRule) {
      setData((prev) => ({ ...prev, rule: selectedRule?.id }));
    }
    const cond = rules?.find((r) => r.id === selectedRule?.id)?.conditions;
    setConditions(cond);
  }, [rules, selectedRule, setAssignType, setData]);

  useEffect(() => {
    if (departmentData && Array.isArray(departmentData)) {
      const mapped = departmentData.map((dept) => ({
        ...dept,
        selected: dept.isSelected,
        roles: dept.roles.map((role) => ({
          ...role,
          selected: role.isSelected,
          mandatory: role.mandatory || false,
        })),
      }));
      setDepartment(mapped);
      const roleObjects = mapped
        .flatMap((dept) => dept.roles)
        .filter((role) => role.selected)
        .map((role) => ({
          id: role.id,
          mandatory: role.mandatory,
        }));

      setData((prev) => ({
        ...prev,
        departmentRoleIds: roleObjects,
      }));
    }
  }, [departmentData, setData]);

  const updateSelectedRoles = (updatedDepartments) => {
    const roleObjects = updatedDepartments
      .flatMap((dept) => dept.roles)
      .filter((role) => role.selected)
      .map((role) => ({
        id: role.id,
        mandatory: role.mandatory,
      }));

    setData((prev) => ({
      ...prev,
      departmentRoleIds: roleObjects,
    }));
  };

  const handleAssign = ({ target: { value } }) => {
    setAssignType(value);
  };
  const handleCheckbox = (e) => {
    const { value, checked } = e.target;
    const roleId = parseInt(value, 10);

    const updatedDepartments = department.map((dept) => ({
      ...dept,
      roles: dept.roles.map((role) => (role.id === roleId ? { ...role, selected: checked } : role)),
    }));

    setDepartment(updatedDepartments);
    updateSelectedRoles(updatedDepartments);
  };

  const handleSelectAllRoles = (deptId, isSelected) => {
    const updatedDepartments = department.map((dept) =>
      dept.id === deptId
        ? {
            ...dept,
            selected: isSelected,
            roles: dept.roles.map((role) => ({
              ...role,
              selected: isSelected,
            })),
          }
        : dept,
    );

    setDepartment(updatedDepartments);
    updateSelectedRoles(updatedDepartments);
  };

  const setMandatoryFn = (e) => {
    const roleId = parseInt(e.target.name, 10);
    const isChecked = e.target.checked;

    const updatedDepartments = department.map((dept) => ({
      ...dept,
      roles: dept.roles.map((role) => (role.id === roleId ? { ...role, mandatory: isChecked } : role)),
    }));

    setDepartment(updatedDepartments);
    updateSelectedRoles(updatedDepartments);
  };

  return (
    <Grid container direction="column" style={{ padding: '10px' }}>
      <Grid item>
        <Grid container direction="row" spacing={1} justifyContent="flex-start" alignItems="center">
          <Grid item xs={1}>
            <CustomPopupText text="Assign To:" />
          </Grid>
          <Grid item xs={11}>
            <CustomRadioGroup
              id="assign"
              handleChange={handleAssign}
              options={assignOption}
              name="assign"
              value={assignType}
            />
          </Grid>
        </Grid>
      </Grid>
      {assignType === 'department' && (
        <Department
          department={department}
          handleSelectAllRoles={handleSelectAllRoles}
          handleCheckbox={handleCheckbox}
          setMandatoryFn={setMandatoryFn}
        />
      )}
      {assignType === 'rule' && (
        <Rule
          rules={rules}
          conditions={conditions}
          rule={data?.rule}
          setData={setData}
          setConditions={setConditions}
          mandatoryRuleCoditions={mandatoryRuleCoditions}
          setMandatoryRuleCoditions={setMandatoryRuleCoditions}
        />
      )}
    </Grid>
  );
};

export default RoleMapping;
